import * as THREE from 'three';
import { MultiWait } from '../util/multiwait';

const SHADER_DATA_PATH = 'shaders/';

/**
 * @private
 */
class _ShaderManager {
  shaders: any;
  materials: any;
  waitAll: any;

  constructor() {
    this.shaders = {};
    this.materials = {};
    this.waitAll = new MultiWait();
  }

  _loadShader(path: any, callback: any) {
    const existingShader = this.shaders[path];
    if (existingShader) {
      if (existingShader.shader) {
        callback(existingShader.shader);
      } else {
        existingShader.waiters.push(callback);
      }
      return;
    }

    const newShader = {
      shader: null,
      waiters: [callback]
    };
    this.shaders[path] = newShader;

    const loader = new THREE.FileLoader();
    loader.load(path, (data: any) => {
      newShader.shader = data;
      for (let i = 0; i < newShader.waiters.length; ++i) {
        newShader.waiters[i](data);
      }
      newShader.waiters = [];
    });
  }

  register(name: any, vertShader: any, fragShader: any, options?: any) {
    const waitAllParts = new MultiWait();

    let vertShaderData: any = null;
    const vertShaderWait = waitAllParts.one();
    this._loadShader(SHADER_DATA_PATH + vertShader, function(data: any) {
      vertShaderData = data;
      vertShaderWait();
    });

    let fragShaderData: any = null;
    const fragShaderWait = waitAllParts.one();
    this._loadShader(SHADER_DATA_PATH + fragShader, function(data: any) {
      fragShaderData = data;
      fragShaderWait();
    });

    const shaderWait = this.waitAll.one();
    waitAllParts.wait(() => {
      if (!options) {
        options = {};
      }
      options.vertexShader = vertShaderData;
      options.fragmentShader = fragShaderData;
      if (!options.uniforms) {
        options.uniforms = [];
      }
      const shaderMaterial = new THREE.ShaderMaterial(options);
      this.materials[name] = shaderMaterial;
      shaderWait();
    });
  }

  init(callback: any) {
    this.waitAll.wait(callback);
  }

  get(name: any) {
    return this.materials[name];
  }
}

/**
 * @global
 * @type {_ShaderManager}
 */
export const ShaderManager = new _ShaderManager();
